import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";
import { token } from "./AuthAction";

export const getProfileDetails = (model) => {
  const url = `${CONFIG.BASE_URL}/university/getuniversity`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
